import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import {
    Router,
    NavigationStart,
    NavigationEnd,
    NavigationCancel,
    NavigationError
} from '@angular/router';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UIService {
    constructor(private router: Router) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.setLoadingState(true);
            }
            if (
                event instanceof NavigationEnd ||
                event instanceof NavigationCancel ||
                event instanceof NavigationError
            ) {
                this.setLoadingState(false);
            }
        });
    }

    // Global Loader
    private loadingStateSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    public loadingState$: Observable<boolean> = this.loadingStateSubject
        .asObservable()
        .pipe(distinctUntilChanged()); // Can use debounceTime to slow down
      
    public setLoadingState(state: boolean): void {
        this.loadingStateSubject.next(state);
    }
}
